<template>
  <div class="project-wampper panoramic-wampper">
    <div class="qr-code">
      <img :src="QRCODEImgSrc" alt="">
    </div>
    <iframe
      frameborder="0"
      width="100%"
      height="100%"  
      :src="panoramicSrc">
    </iframe>
  </div>
</template>

<script>
export default {
  name: "panoramic",
  components: {},
  data() {
    return {
      QRCODEImgSrc: '',
      panoramicSrc: '',
      // QRCODEImgSrc:'https://www.probim.cn:8080/api/User/Document/QRCode?encodedUrl=http%3A%2F%2Fwww.probim.cn%3A8888%2F%23%2FLinkShare%2FPanoShare%2F1002b2d9-d96b-d074-698c-4bca691393f2%2F50032fbd-28d7-4d6a-9a87-040a5073a6f3', // 二维码
      
      // 720全景图地址panoramicSrc 该地址：去掉工具栏传参isDis=1    去掉VR、当前视点、GIS传参  hideGIS=1&hideVR=1&hideView=1 

      // panoramicSrc: 'http://www.probim.cn:8888/Panorama/1/0/0/2/b/2/d/9/1002b2d9-d96b-d074-698c-4bca691393f2/vtour/tour2.html?organizeId=50032fbd-28d7-4d6a-9a87-040a5073a6f3&isDis=1&panoapiurl=http%3A%2F%2Fwww.probim.cn%3A8508&gisurl=http%3A%2F%2Fwww.probim.cn%3A8888%2FPanorama%2Fgis.html%3Ftest%3D1&hideGIS=1&hideVR=1&hideView=1'
    };
  },
  props: {
    
	},
  mounted() {
    this.QRCODEImgSrc = `${this.$project.projectData.platform.QRCODEImgSrc}`
    this.panoramicSrc = `${this.$project.projectData.platform.panoramicSrc}`
  },
  methods: {
    
  },
  watch: {},
  beforeDestroy(){
    this.panoramicSrc = ''
  }
};
</script>

<style lang="scss" scoped>
.panoramic-wampper{
  width:100%;
  height: 100%;
  position: relative;
}
.qr-code{
  position: absolute;
  right: 30px;
  bottom: 30px;
  width: 112px;
  height: 112px;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>